import React, { useEffect, useState } from "react";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";
import BuySell from "./BuySell";
import Features from "./Features";
import Meetscotty from "./Meetscotty";
import Tokonomics from "./Tokonomics";
import Companions from "./Companions";
import HowtoBuy from "./HowtoBuy";
import Faq from "./Faq";
import SignUp from "./SignUp";
import RoadMap from "./RoadMap";
import AOS from "aos";
import "aos/dist/aos.css";
import { useParams } from "react-router-dom";
import { useSetCheckReferralUrlMutation } from "../../../redux/user";
import YoutubeSlider from "./YoutubeSlider";

function Home() {
  const { referral_code } = useParams();
  const [setCheckReferralUrl] = useSetCheckReferralUrlMutation();
  const [referralStatus, setReferralStatus] = useState(true);
  const [referralCode, setReferralCode] = useState("");
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 400,
      easing: "ease-in-sine",
      delay: 100,
    });
  });

  useEffect(() => {
    if (referral_code) {
      setCheckReferralUrl({ referral_code }).then((result) => {
        if (result.data.status) {
          setReferralStatus(result.data.status);
          localStorage.setItem("referral_code", referral_code);
          setReferralCode(referral_code);
        } else {
          setReferralStatus(result.data.status);
        }
      });
    }else{
      localStorage.removeItem("referral_code")
    }
  }, [referral_code]);

  useEffect(() => {
    if (localStorage.getItem("referral_code")) {
      setReferralCode(localStorage.getItem("referral_code"));
    }
  }, []);

  return (
    <div>
      {!referralStatus ? (
        <h2 className="text-center">Invalid Url</h2>
      ) : (
        <>
          <Header/>
          <section className="bg">
            <BuySell referralCode={referralCode}/>
            <Features />
            <YoutubeSlider/>
            <Meetscotty />
            <Companions />
            <Tokonomics />
            <RoadMap />
            <HowtoBuy />
            <Faq />
            <SignUp />
          </section>
          <Footer />
        </>
      )}
    </div>
  );
}

export default Home;
